import axios from "axios";
import { BASEURL } from "../../baseUrl";
import { toast } from "react-toastify";

export const LOGIN_ADMIN = 'LOGIN_ADMIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const SEND_OTP = 'SEND_OTP';
export const MASTER_DASHBOARD = 'MASTER_DASHBOARD';
export const GET_USER_DATA = 'GET_USER_DATA';
export const BATCH_DROPDOWN = 'BATCH_DROPDOWN';
export const PATIENT_DROPDOWN = 'PATIENT_DROPDOWN';

console.log("BASEURL",BASEURL);

const adminLoginAction = (payload) => ({ type: LOGIN_ADMIN, payload: payload });
const loginAction = (payload) => ({ type: LOGIN_SUCCESS });
const logoutAction = (payload) => ({ type: LOGOUT_SUCCESS });
const sendOtpAction = (payload) => ({ type: SEND_OTP, payload: payload });
const masterDashboardAction = (payload) => ({ type: MASTER_DASHBOARD, payload: payload });
const getUserDataAction = (payload) => ({ type: GET_USER_DATA, payload: payload });
const batchDropdownAction = (payload) => ({ type: BATCH_DROPDOWN, payload: payload });
const patientDropdownAction = (payload) => ({ type: PATIENT_DROPDOWN, payload: payload });

export const adminLogin = (payload) => {
    return async (dispatch) => {
        try {
            await axios.post(`${BASEURL}/auth/login`, payload).then(((res) => {
                toast.success('OTP Send successfully')
                dispatch(adminLoginAction(res));
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(adminLoginAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)

            console.log('Error login user:', error);
        }
    }
}

export const loginSuccess = () => {
    return {
        type: 'LOGIN_SUCCESS',
    };
}

export const logoutSuccess = () => {
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('token');
    localStorage.removeItem('type');
    return {
        type: 'LOGOUT_SUCCESS',
    };
}

export const sendOtp = (payload) => {
    return async (dispatch) => {
        try {
            await axios.post(`${BASEURL}/auth/verifyOtp`, payload).then(((res) => {
                toast.success('Login successfully')
                dispatch(sendOtpAction(res));
                dispatch(loginAction());
                localStorage.setItem('isAuthenticated', 'true');
                localStorage.setItem('lastLoginTime', Date.now().toString());
                localStorage.setItem('token', res?.data?.user?.token)
                localStorage.setItem('userName', res?.data?.user?.name)
                localStorage.setItem('email', res?.data?.user?.email)
                localStorage.setItem('role', res?.data?.user?.role)
            })).catch((error) => {
                console.log("Error", error);
                toast.error('Something went wrong')
                dispatch(sendOtpAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const masterDashboard = (date, month, startDate, endDate) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/reports/dashboardCounts?date=${date}&monthDate=${month}&startDate=${startDate}&endDate=${endDate}`).then(((res) => {
                dispatch(masterDashboardAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(masterDashboardAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const getUserData = () => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token')
            await axios.get(`${BASEURL}/auth/getAuthData`, {
                headers: {
                    authorization: `Bearer ${token}`
                }
            }).then(((res) => {
                dispatch(getUserDataAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(getUserDataAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const batchDropdown = (payload) => {
    return async (dispatch) => {
        try {
            await axios.post(`${BASEURL}/master/getBatchByProduct`, payload).then(((res) => {
                dispatch(batchDropdownAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(batchDropdownAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const patientDropdown = () => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/master/getAllPatients`).then(((res) => {
                dispatch(patientDropdownAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(patientDropdownAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}